import { connect } from 'react-redux';
import getHasFatalError from 'stores/selectors/getHasFatalError';
import ErrorBoundary from './ErrorBoundary';

const mapStateToProps = state => ({
  fatalAjaxResponseOccurred: getHasFatalError(state),
});

export default connect(mapStateToProps)(ErrorBoundary);
